import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import UndoIcon from "@mui/icons-material/Undo";
import moment from "moment";

export default function DashboardFilter(props) {
  const {
    applyFilters,
    clearFilters,
    setStartDate,
    startDate,
    setEndDate,
    endDate,
    selectedOccurancePeriod,
    setSelectedoccurancePeriod,
  } = props;

  const handleOccurrencePeriodChange = (value) => {
    setSelectedoccurancePeriod(value);

    if (value === "today") {
      setStartDate(moment().startOf("day").toDate());
      setEndDate(null);
    } else if (value === "yesterday") {
      setStartDate(moment().subtract(1, "day").startOf("day").toDate());
      setEndDate(null);
    } else if (value === "custom_dates") {
      setStartDate(null);
      setEndDate(null);
    }
  };

  return (
    <form>
      <FormControl required fullWidth margin="normal">
        <InputLabel id="period-select-label">Occurrence Period</InputLabel>
        <Select
          labelId="period-select-label"
          value={selectedOccurancePeriod}
          onChange={(e) => handleOccurrencePeriodChange(e.target.value)}
          label="Occurrence Period"
        >
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="yesterday">Yesterday</MenuItem>
          <MenuItem value="custom_dates">Custom Dates</MenuItem>
        </Select>
      </FormControl>

      {/* Only show Start and End date for custom_dates */}
      {selectedOccurancePeriod === "custom_dates" && (
        <>
          <TextField
            required
            label="Start Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={startDate ? moment(startDate).format("YYYY-MM-DD") : ""}
            onChange={(e) => setStartDate(moment(e.target.value).toDate())}
            inputProps={{
              max: moment().format("YYYY-MM-DD"), // Disable future dates
            }}
          />
          <TextField
            required
            label="End Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={endDate ? moment(endDate).format("YYYY-MM-DD") : ""}
            onChange={(e) => setEndDate(moment(e.target.value).toDate())}
            inputProps={{
              max: moment().format("YYYY-MM-DD"), // Disable future dates
            }}
          />
        </>
      )}

      <div className="text-end mt-3">
        <Button
          variant="outlined"
          startIcon={<UndoIcon />}
          onClick={clearFilters}
          sx={{ mr: 1 }}
        >
          Clear Filter
        </Button>
        <Button
          variant="contained"
          startIcon={<FilterListIcon />}
          onClick={applyFilters}
        >
          Apply Filters
        </Button>
      </div>
    </form>
  );
}
